const t = (e) => e.split(".").pop();
export {
  t as getFileExtension
};
//# sourceMappingURL=file.mjs.map
